import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingRoutingModule } from './landing-routing.module';
import { LandingComponent } from './landing.component';
import { SharedModule } from '../shared/shared.module';
import { MiddlewareComponent } from '../middleware/middleware.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { VerifiedPnlModule } from '../features/verified-pnl/verified-pnl.module';

@NgModule({
  declarations: [
    LandingComponent,
    MiddlewareComponent,
    ThankYouComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    LandingRoutingModule,
    VerifiedPnlModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

})
export class LandingModule { }
